import React from "react";

const SectionOne = () => {
  return (
    <div className="section-one-container12 pb-5">
      <div className="container " style={{ overflow: "hidden" }}>
        <div className="row mt-4 align-items-center">
          {/* LEFT: Image + Overlays */}
          <div className="col-12 col-lg-6 d-flex justify-content-center flex-column align-items-center position-relative  mb-lg-0">
            <div className="torn-image-background w-100 position-relative">
              <img
                style={{ maxHeight: "450px" }}
                src="./images/Borrow-01.jpg"
                className="main-children-image img-fluid"
                alt="Children"
              />
            </div>
          </div>

          <div
            className="col-12 col-lg-6 d-flex flex-column right-column-border position-relative z-1 bg-white bg-opacity-75 p-4 rounded"
            // style={{ bottom: "110px" }}
          >
            <p className="about-us-subtitle-right-column">
              <span className="about-us-line-dashed"></span>
            </p>
            <h1 className="share-circle-heading-left fw-bold">
              <span className="share-support-text text-black">Borrow</span>
            </h1>
            <p className="share-circle-subheading-left">
              By being a responsible borrower, You enable others to thrive also
            </p>

            <ul
              className="share-circle-description-list-icon"
              // style={{ height: "60vh" }}
            >
              {/* <li>By being a responsible borrower, you enable others to thrive also.</li> */}
              <li>
                The Share-Circle Borrow service is available, where you have an
                authorized CSP.
              </li>
              <li>
                These will initially be where a local person is familiar with
                Bitcoin and Lightning, and has joined Share-Circle as a Lending
                Partner (Community Support Partner - CSP).
              </li>
              <li>
                If there is no local authorized CSP, you can talk to a
                responsible local community support organization and ask if they
                are familiar with Bitcoin, and ask if they could join the
                Share-Circle Community Support Partner (CSP) Program.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
